import React from 'react';
import { useSelector } from 'react-redux';

import {
    Alert,
    FormField,
    FormHelp,
    Input,
    Label,
    Spacer,
} from '@zillow/constellation';

import { UserSelectors } from 'app/shared/selectors';

import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';

const ContactTextInput = (props) => {
    const {
        errorObj,
        fieldKey,
        isDisabled,
        isRequired,
        labelName,
        onChange,
        updateOnFocus,
        savePropertyData,
        updateFormData,
        value,
    } = props;
    const { email } = useSelector(state => UserSelectors.makeUser(state));
    const [hasFocus, setHasFocus] = React.useState(false);

    const handleBlur = (e, contactType) => {
        updateFormData({ [fieldKey]: e.target.value });
        savePropertyData(
            contactType,
            e.target.value,
            {
                componentGroupName:
                AnalyticsConstants.LISTING_COMPONENT_GROUP_NAME.CONTACT_INFO,
            }
        ).finally(() => setHasFocus(false));
    };

    const handleFocus = () => {
        setHasFocus(true);
        updateOnFocus(fieldKey, value);
    };

    const lowercaseEmail = email && email.toLowerCase();
    const lowercaseValue = value && value.toLowerCase();

    return (
        <FormField marginBottom="sm">
            <Label required={isRequired}>{labelName}</Label>
            <Input
                aria-label={labelName}
                disabled={isDisabled}
                error={!!errorObj[fieldKey]}
                name={fieldKey}
                onBlur={e => handleBlur(e, fieldKey)}
                onChange={e => onChange(e.target.value)}
                onFocus={handleFocus}
                value={value}
            />
            {errorObj[fieldKey] && (
                <FormHelp error={!!errorObj[fieldKey]} dangerouslySetInnerHTML={{ __html: errorObj[fieldKey] }} />
            )}
            {!errorObj[fieldKey] && fieldKey === 'contactEmail' && !hasFocus && lowercaseEmail !== lowercaseValue && (
                <Spacer paddingTop="md">
                    <Alert appearance="warning" body="This contact email differs from your Zillow account email." />
                </Spacer>
            )}
        </FormField>
    );
};

export default ContactTextInput;
